import Cookies from 'js-cookie'
import { LOCALSTORAGE_ROUTE_NAME } from 'config'

const SESSION_KEY = 'golfgamebook-office-session-auth-token'
const SESSION_MFA_KEY = 'golfgamebook-office-session-mfa'

export const setSessionToken = (token: any): void => {
  Cookies.set(SESSION_KEY, token, { expires: 1 })
}

export const destroySessionData = (): void => {
  Cookies.remove(SESSION_KEY)
  Cookies.remove(SESSION_MFA_KEY)
  removeEntryPath()
}

export const getSessionToken = (): string => {
  return Cookies.get(SESSION_KEY) || ''
}

export const setSessionMfaKey = (key: any): void => {
  Cookies.set(SESSION_MFA_KEY, key, { expires: 1 })
}

export const getSessionMfaKey = (): string => {
  return Cookies.get(SESSION_MFA_KEY) || ''
}

export const setEntryPath = (path: string): void => {
  try {
    window.localStorage.setItem(LOCALSTORAGE_ROUTE_NAME, path)
  } catch (e) {
    window.console.warn('Could not store entry path')
  }
}

export const getEntryPath = (): string => {
  return window.localStorage.getItem(LOCALSTORAGE_ROUTE_NAME) || ''
}

export const removeEntryPath = (): void => {
  window.localStorage.removeItem(LOCALSTORAGE_ROUTE_NAME)
}
